<script lang="ts">
export default {
    name: 'XyzLayer',
    props: {
        layer: { type: Object, required: true },
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    },
}
</script>

<template>
    <ol-tile-layer
        :title="layer.title" :visible="layer.show" :class-name="layer.name" :properties="{ ...layer }" :attributions="[layer.attribution]"
        :z-index="layer.zIndex"
    >
        <ol-source-xyz
            :url="layer.url"
            :attributions="layer.attribution"
            crossOrigin="anonymous"
        />
    </ol-tile-layer>
</template>

<style scoped>

</style>
